<template>
    <section class="custom-assess-box"  v-loading="loading">
        <div class="section-box" v-for="(par,parIndex) in allData" :key="par.id">
            <h5>{{par.name}}<div class="pm-preview-padding" v-show="preview">({{par.max_score}}分)</div>&nbsp;&nbsp;&nbsp;
                <el-input v-show="!preview" type="number" min=0 max=100 size="mini" v-model="par.max_score" placeholder="总得分"></el-input>
                <el-button v-show="!preview" @click="newPm('新建模块',`${parIndex+1}`)" type="text">新建模块</el-button>
                <el-button v-show="!preview" @click="newPm('新建项目',`${parIndex+1}`)" type="text">新建项目</el-button>
            </h5>
            <div class="pm-childs-box" v-for="(item,itemIndex) in par.childs" :key="item.id">
                <el-row v-if="(item.logic_type === '' || item.logic_type === null) && item.static_logic != '8'">
                    <el-col :span="16">
                        <span class="pm-chil-col">{{item.name}} ({{item.max_score}}分)</span>
                        <el-button v-show="!preview" @click="newPm('新建模块项目',`${parIndex+1}-${itemIndex+1}`,item.id)" type="text">新建模块项目</el-button>
                        <el-button v-show="!preview" class="button-color-delete" @click="deletePm(parIndex,itemIndex)" type="text">删除</el-button></el-col>
                </el-row>
                <div v-if="item.childs && item.childs.length">
                    <div v-for="(items,itemsIndex) in item.childs" :key="items.id">
                        <el-row class="formRow" v-if="items.logic_type==1">
                            <el-col :span="3" style="margin-top:8px"><div>{{items.name}} <span v-show="!(items.assess_type==1 && items.static_logic ==1 && items.logic_type == 1)">({{items.max_score}}分)</span></div></el-col>
                            <el-col :span="5" style="margin-top:8px" v-for="(par,index) in items.seleData" :key="index">
                                <label v-if="!(items.assess_type==1 && items.static_logic ==1 && items.logic_type == 1)" style="width:40px">{{par.label}} </label><span><el-input style="width:120px" size="mini"></el-input></span>
                            </el-col>
                            <el-col :span="5" style="margin-top:8px">
                                <label style="width:40px">实际得分 </label><span><el-input style="width:120px" size="mini"></el-input></span>
                            </el-col>
                            <el-col :span="1" v-show="!preview"><el-button class="button-color-delete" @click="deletePm(parIndex,itemIndex,itemsIndex)" type="text">删除</el-button></el-col>
                        </el-row>
                        <el-row v-if="items.logic_type==0">
                            <el-col :span="20" style="margin:10px 0;margin-left:20px">
                                <span class="pm-chil-col" style="float:left;line-height:24px">{{items.name}} ({{items.max_score}}分)</span>
                                <span v-show="items.data_name" style="width:40px">{{items.data_name}}:</span><span v-show="items.data_name" style="width:80px;border-bottom: 1px solid;display: inline-block;margin-left: 10px"></span>
                                <span style="width:80px;display: inline-block;padding-left:20px">实际得分:</span><span style="width:80px;border-bottom: 1px solid;display: inline-block;margin-left: 20px"></span>
                                <el-tooltip class="item" effect="dark" :content="importSelect.find(t => t.value == items.static_logic).label" placement="right">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="1" v-show="!preview"><el-button style="padding-left:20px" class="button-color-delete" @click="deletePm(parIndex,itemIndex,itemsIndex)" type="text">删除</el-button></el-col>
                        </el-row>
                    </div>
                </div>
                <div v-if="!item.childs && item.logic_type==1">
                    <el-row>
                        <el-col :span="22" style="margin:10px 0">
                            <span class="pm-chil-col" style="min-width: 120px;float:left;line-height:24px">{{item.name}} ({{item.max_score}}分)</span>
                            <div v-for="(par,index) in item.seleData" :key="index" style="float:left;margin-left:10px">
                                <label style="width:40px" >{{par.label}}</label><span><el-input style="width:120px;" size="mini"></el-input></span>
                            </div>
                            <label style="width:40px;margin-left:20px">实际得分</label><span><el-input style="width:120px" size="mini"></el-input></span>
                        </el-col>
                        <el-col :span="1" v-show="!preview"><el-button class="button-color-delete" @click="deletePm(parIndex,itemIndex)" type="text">删除</el-button></el-col>
                    </el-row>
                </div>
                <div v-if="!item.childs && item.logic_type==0">
                    <el-row>
                        <el-col :span="20" style="margin:10px 0">
                            <span class="pm-chil-col" style="float:left;line-height:24px">{{item.name}} ({{item.max_score}}分)</span>
                            <span v-show="item.data_name" style="width:40px">{{item.data_name}}:</span><span v-show="item.data_name" style="width:80px;border-bottom: 1px solid;display: inline-block;margin-left: 10px"></span>
                            <span style="width:80px;display: inline-block;padding-left:20px">实际得分:</span><span style="width:80px;border-bottom: 1px solid;display: inline-block;"></span>
                            <el-tooltip class="item" effect="dark" :content="importSelect.find(t => t.value == item.static_logic).label" placement="right">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="1" v-show="!preview"><el-button class="button-color-delete" @click="deletePm(parIndex,itemIndex)" type="text">删除</el-button></el-col>
                    </el-row>
                </div>
            </div>
            <dl v-if="par.name==='管理能力' &&　par.childs.length>0" style="padding-left:20px">
                <dt v-show="!preview">全组成绩
                    <el-switch
                    v-model="groupSwitch"
                    >
                    </el-switch>
                </dt>
                <dd v-show="groupSwitch" class="group-con-box"><span>全组考勤:</span><span  class="pm-dl-span"></span>
                <span class="pm-dl-span-left">全组时间管理:</span><span  class="pm-dl-span"></span>
                <span class="pm-dl-span-left">全组工作达成:</span><span  class="pm-dl-span"></span>
                <span class="pm-dl-span-left">全组工作能力:</span><span  class="pm-dl-span"></span>
                <span class="pm-dl-span-left">全组管理能力:</span><span  class="pm-dl-span"></span>
                <span class="pm-dl-span-left">实际得分:</span><span  class="pm-dl-span"></span></dd>
            </dl>
            <p class="pm-footer-p" v-if="par.childs.length>0">
                总分:<span class="totalTxt"></span>
            </p>
        </div>

        <el-dialog title="新建评论类型项目" :visible.sync="dialogTableVisible" width="1000px" @close="initData">
            <template>
                <el-table
                    :data="tableData"
                    border
                    >
                    <el-table-column prop="pm"  label="" header-align="center" align="center">
                        <template slot="header" slot-scope="scope">
                            <el-input placeholder="项目" v-model="headerData.title"></el-input>
                            <span v-if="false">{{scope}}</span>
                        </template>
                        <template slot-scope="scope">
                            <el-select @change="evaluateChange" v-model="scope.row.value">
                                <el-option v-for="item in pmData" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column  prop="pmScore" label=""  header-align="center" align="center">
                        <template slot="header" slot-scope="scope">
                            <el-input type="number" min=0 max=100 placeholder="得分" v-model="headerData.score"></el-input>
                            <span v-if="false">{{scope}}</span>
                        </template>
                        <template slot-scope="scope">
                            <el-input style="width:150px" v-model="scope.row.percent" type="number" max=100>
                                <template slot="append">%</template>
                            </el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <el-row style="margin-top:10px;">
                <div>
                    <span>公式计算：</span>
                    <div>
                        <span>得分：</span>
                        <span v-for="(item,index) in tableData" :key="index">
                            <span v-if="item.percent && item.value">
                                <span v-if="index!=0">+</span>
                                <span>{{pmData.find(t=>t.value==item.value).label}}{{item.percent}}%</span>
                            </span>
                        </span>
                    </div>
                </div>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="subCustomData">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="选择类型" :visible.sync="typeVisible" width="500px">
            <el-row style="text-align:center;">
                <el-col :span="12"><el-button type="primary" @click="importVisible=true;typeVisible=false">导入类型</el-button></el-col>
                <el-col :span="12"><el-button type="primary" @click="dialogTableVisible=true;typeVisible=false">评论类型</el-button></el-col>
            </el-row>
        </el-dialog>

        <el-dialog title="新建导入类型项目" :visible.sync="importVisible" @close="initData">
            <el-row style="text-align:center;">
                <el-col :span="24"><el-input v-model="importData.name" placeholder="项目名"></el-input></el-col>
                <el-col :span="24"><el-input style="margin-top:20px" type="number" min=0 max=100 v-model="importData.value" placeholder="得分"></el-input></el-col>
                <el-col :span="24"><el-input style="margin-top:20px" v-model="importData.explain" placeholder="数据名"></el-input></el-col>
                <el-col :span="24">
                    <template>
                        <el-select v-model="importData.type" style="width:100%;margin-top:20px">
                            <el-option v-for="item in importSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importVisible = false">取 消</el-button>
                <el-button type="primary" @click="setImportData" >确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="新建模块" :visible.sync="moduleVisible" width="500px">
            <el-row style="text-align:center;">
                <el-col :span="24"><el-input v-model="newModule.newModuleNmae" placeholder="模块名"></el-input></el-col>
                <el-col :span="24"><el-input style="margin-top:20px" type="number" min=0 max=100 v-model="newModule.newModuleValue" placeholder="模块分"></el-input></el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="moduleVisible = false">取 消</el-button>
                <el-button type="primary" @click="moduleClick">确 定</el-button>
            </div>
        </el-dialog>
    </section>
</template>
<script>
import { tableSeleType,designFormulas } from '@/assets/js/message.js'
export default {
    data(){
        return {
            dialogTableVisible:false,
            moduleVisible:false,
            customVisible:false,
            typeVisible:false,
            importVisible:false,
            loading:true,
            typePm:1,                   //1-工作达成，2-工作能力，3管理能力
            typeId:'',
            tableData:[],
            capacityPmData:[],          //工作能力数据
            index:1,                    //新建项目对应模块
            newModule:{                 //新建模块数据
                newModuleNmae:'',   
                newModuleValue:'',
            },
            importData:{},
            headerData:{},              //新建评论类型头部数据
            pmData:[],
            importSelect:[],            //导入计算公式
            sumScore:[],
            allData:[],
            groupSwitch:false,           //是否使用全组成绩
        }
    },
    props:['preview'],
    created(){
        this.initData();
        this.pmData=[...tableSeleType];
        this.importSelect=designFormulas;
        if(JSON.stringify(this.$route.query) !== '{}'){
			this.getRestoreData(this.$route.query.formId)
		}else{
            this.loading=false
        }
    },
    methods:{
        getRestoreData(id){
            this.$http.get('/template/getCustom',{params:{template_id:id}}).then((v)=>{
                if(v.status === 200){
                    if(v.data.data.custom_items.length != 0){
                        this.$emit('setShift',v.data.data.shift === 1 ? true : false);
                        const sortArr=['工作达成',"工作能力","管理能力"];
                        sortArr.forEach((item)=>{
                            this.allData.push(this.setRestoreData(v.data.data.custom_items).find(v=>v.name===item))
                        })
                    }else{
                        this.allData=this.initAlldata();
                    }
                }
                this.loading=false
            }).catch(()=>{this.loading=false})
        },
        setRestoreData(params){ //还原数据处理
            let cloneData = JSON.parse(JSON.stringify(params))    // 对源数据深度克隆
            return cloneData.filter(father=>{               
                let branchArr = cloneData.filter(child=>father.id == child.parent_id)    //返回每一项的子级数组
                if(father.logic_type == 1)  father.seleData=this.setSeleData(father);
                father.name=father.item_name;
                if(father.name === '全组成绩') this.groupSwitch=true;
                if(father.parent_id ==  "00000000-0000-0000-0000-000000000000" ){
                    father.parent_id='0';
                    father.childs=[];
                }
                branchArr.length>0 ? father.childs = branchArr : ''   //如果存在子级，则给父级添加一个childs属性，并赋值
                return father.parent_id=="0";                     //返回第一层
            });
        },
        setSeleData(v){
            const assess_type=v.assess_type.split(',');
            const assess_percentage=v.assess_percentage.split(',');
            let param=[];
            assess_type.map((item)=>{
                param.push(this.pmData.find(t=>t.value==item))
            })
            return param;
        },
        initAlldata(){      //设置初始提交数据
            let data=[]
            for(let i=1;i<4;i++){
                let param={
                    parent_id:'0',        //父ID
                    logic_type:'',
                    assess_type:'',
                    static_logic:'',
                    data_name:'',
                    assess_percentage:'',
                    id:String(i),
                    name:i==1?'工作达成':i==2?'工作能力':'管理能力',
                    max_score:this.sumScore[i-1] || '',
                    childs:[],
                }
                data.push(param)
            }
            return data
        },
        initData(){
            this.tableData=[];
            this.calculate=[];
            for(let i=0;i<5;i++){
                this.tableData.push({
                    label:'',
                    value:'',
                    percent:'',
                })    
            }
            for(let i=0;i<2;i++){
                this.calculate.push({
                    label:'',
                    value:'',
                    percent:'',
                })    
            }
            this.headerData={
                title:'',
                score:'',
            }
            this.importData={
                name:'',
                value:'',
                explain:'',
                type:'',
            }
        },
        newPm(name,v,id){               //新建
            this.typePm=v;
            this.newModule={ newModuleNmae:'',newModuleValue:''}
            if(name === '新建模块'){
                this.moduleVisible=true;
            }else{
                this.typeId=id;
                this.typeVisibleDialog();
            }
        },
        subCustomData(){            //评论类型新增    
            const typePm=this.typePm;
            const headerData=this.headerData;
            if(!headerData.title || !headerData.score || !this.setTableSeleData().length){
                this.$message({message:'请正确填写数据！',type:'error'});
                return;
            }
            let list=[];
            let par=[];
            const param={
                logic_type:'1',
                name:headerData.title,
                assess_type:'',
                static_logic:'',
                data_name:'',
                assess_percentage:'',
                max_score:headerData.score,
                seleData:this.setTableSeleData(),
                ...this.setCalculateData()
            }
            if(param.assess_type == 6){ // 处理不计算类型
                param.assess_type=1
                param.static_logic=1
            }
            list=this.allData[typePm[0]-1]['childs']
            par=[...list];
            if(!isNaN(typePm)){    //是否直接新建项目 
                param.id=`${typePm}-${list.length}`;
                param.parent_id=String(this.allData[typePm[0]-1]['id']);
                list.push(param)
            }else{                          //模块下新建项目
                par.map((v)=>{
                    if(v.id == this.typeId){
                        if(!v.childs) v.childs=[];
                        param.id=`${typePm}-${v.childs.length+1}`;
                        param.parent_id=String(v.id);
                        v.childs.push(param)
                    }
                })
                list=par;
            }
            this.dialogTable()
            this.initData() //  重置评论选择类型数据
        },
        setImportData(){            //新建导入类型项目
            const typePm=this.typePm;
            const importData=this.importData;
            if(!importData.name || !importData.value){
                this.$message({message:'请正确填写数据！',type:'error'});
                return;
            }else if(importData.type === ''){
                this.$message({message:'请选择计算逻辑数据！',type:'error'});
                return;
            }
            let list=[];
            let par=[];
            const param={
                name:importData.name,
                logic_type:'0',
                max_score:importData.value,
                assess_type:'',
                assess_percentage:'',
                static_logic:String(importData.type),
                data_name:importData.explain,
            }
            list=this.allData[typePm[0]-1]['childs']
            par=[...list];
            if(!isNaN(typePm)){    //是否直接导入项目
                param.id=`${typePm}-${list.length}`;
                param.parent_id=String(this.allData[typePm[0]-1]['id']);
                list.push(param)
            }else{                          //模块下导入项目
                par.map((v)=>{
                    if(v.id == this.typeId){
                        if(!v.childs) v.childs=[];
                        param.id=`${typePm}-${v.childs.length}`;
                        param.parent_id=String(v.id);
                        v.childs.push(param)
                    }
                })
                list=par;
            }
            this.importVisible=false;
            this.initData() //  重置评论选择类型数据
        },
        setTableSeleData(){         //选择类型数据
            let param=[];
            this.tableData.map((v)=>{
                if(v.value && v.percent){
                    param.push(this.pmData.find(t=>t.value==v.value))
                }
            })
            return param;
        },
        setCalculateData(){     //计算公式设置
            let param={
                assess_type:'',
                assess_percentage:'',
            }
            const cale=this.setTableSeleData().length;
            this.tableData.map((v,index)=>{
                if(v.value && v.percent){
                    let str=(index+1)!=cale?',':'';
                    param.assess_type+=v.value+str;
                    param.assess_percentage+=v.percent+str;
                }
            })
            return param;
        },
        moduleClick(){          //模块确定
            const typePm=this.typePm;
            const capacityPmData=this.capacityPmData;
            const { newModuleNmae,newModuleValue } = this.newModule;
            if(newModuleNmae!='' && newModuleValue!=''){
                let param={
                    id:`${typePm}-${capacityPmData.length+1}`,
                    parent_id:String(this.allData[typePm-1]['id']),    //父ID
                    name:newModuleNmae,
                    logic_type:'',
                    assess_type:'',
                    static_logic:'',
                    data_name:'',
                    assess_percentage:'',
                    max_score:newModuleValue,
                    childs:[],
                }
                param.id=`${typePm}-${this.allData[typePm-1]['childs'].length}`;
                this.allData[typePm-1]['childs'].push(param)
                this.moduleVisible=false;
            }else{
                this.$message.error('请填写数据！');
            }
        },
        subClick(){             //提交数据
            let param=[];
            this.allData.map((v)=>{
                if(v.name === '管理能力' &&　v.childs.length>0){        //传入全组成绩
                    let isFull=false;
                    v.childs.map((t,index)=>{
                        if(t.name === '全组成绩') isFull=true;
                        if(t.name === '全组成绩' && !this.groupSwitch) v.childs.splice(index,1);    //删除全组成绩
                    })
                    if(!isFull && this.groupSwitch){
                        param.push({
                            id:new Date().getTime(),
                            parent_id:v.id,    //父ID
                            name:'全组成绩',
                            logic_type:'',
                            assess_type:'',
                            static_logic:'8',
                            data_name:'',
                            assess_percentage:'',
                            max_score:'5',
                        })
                    }
                }
                let { childs,...data } = v;        //去除childs,父值
                param.push(data)
            })
            if(this.allData[0]['childs'] && this.allData[0]['childs'].length>0){
                param.push(...this.setSubData(this.allData[0]['childs']))
            }
            if(this.allData[1]['childs'] && this.allData[1]['childs'].length>0){
                param.push(...this.setSubData(this.allData[1]['childs']))
            }
            if(this.allData[2]['childs'] && this.allData[2]['childs'].length>0){
                param.push(...this.setSubData(this.allData[2]['childs']))
            };
            const params={
                template_id:'',
                custom_items:JSON.stringify(param),
            }
            return params;
        },
        setSubData(subData){       //设置提交数据
            let param=[];
            subData.map((v)=>{
                const paramArr=v.childs;
                if(paramArr){
                    paramArr.map((item)=>{
                        let { seleData,...data } = item;        //去除
                        param.push(data)
                    })
                }
                let { childs,seleData,...data } = v;        //去除
                param.push(data)
            })
            return param;
        },
        deletePm(parIndex,chIndex,index){     //删除对应数据
            let allData=JSON.parse(JSON.stringify(this.allData));
            if(index!=undefined){
               delete this.allData[parIndex]['childs'][chIndex]['childs'].splice(index,1)
            }else{
                delete this.allData[parIndex]['childs'].splice(chIndex,1)
            }
        },
        evaluateChange(v){          //评论类型选择
            
        },
        dialogTable(){
            this.dialogTableVisible=!this.dialogTableVisible;
        },
        typeVisibleDialog(){        //选择类型
            this.typeVisible=!this.typeVisible;
        },
    }
}
</script>
<style scoped>
    .custom-assess-box{
        padding: 10px;
        width: 1080px;
        min-height: 100px;
    }
    .section-box{
        border: 1px solid #DCDFE6;
        border-radius: 6px 6px 0 0;
        box-sizing: border-box;
        margin-bottom: 20px
    }
    .section-box>h5{
        border-bottom: 1px solid #DCDFE6;
        padding-left: 10px;
    }
    .section-box>h5>.el-input{
        width: 100px;
        margin-right: 10px;
    }
    .count-ul{
        margin-bottom: 60px;
    }
    .count-ul>li{
        float: left;
        margin-right: 10px;
    }
    .pm-childs-box{
        padding-left: 20px;
    }   
    .pm-childs-box .formRow{
        padding-left: 20px;
        padding-bottom: 20px;
    }
    .pm-chil-col{
        font-size: 14px;
        margin-right: 20px
    }
    .addition{
        float: left;
        line-height: 40px;
        padding: 0 10px;
    }
    .calcu-top{
        margin-top: 20px;
        overflow: hidden;
        width: 224px;
        float: left;
    }
    .button-color-delete{
        color: red;
    }
    .pm-dl-span{
        width:60px;
        border-bottom: 1px solid;
        display: inline-block;
    }
    .pm-dl-span-left{
        margin-left:20px;
    }
    .pm-preview-padding{
        display: inline-block;
        padding: 10px 0;
    }
    .pm-footer-p{
        font-weight: 600;
        font-size: 14px;
        border-top: 1px solid #DCDFE6;
        padding: 10px;
    }
    .totalTxt{
        min-width: 80px; 
        display: inline-block;
        border-bottom: 1px solid #333;
    }
    .group-con-box{
        margin-top: 10px;
    }
    .el-switch{
        margin-left: 20px;
    }
</style>
